import React from "react";
import classnames from "classnames";
import { InfoIcon } from "./Svg";
import Text from "./Text";

const TitleDashboard = ({
  title,
  expanded = false,
  showArrow = true,
  onClick,
  color,
  isModal,
  showInfoIcon = true,
  style = {},
}) => (
  <button
    type="button"
    className={classnames(
      "flex items-center h-full px-4 py-4 relative z-10 bg-critical outline-none justify-between w-full border-0",
      { "cursor-pointer": onClick },
      { "cursor-default": !onClick },
      { "rounded-t-sm rounded-b-none": expanded || isModal },
      { "rounded-sm": !expanded && !isModal },
    )}
    style={{ outline: 0, backgroundColor: color, ...style }}
    onClick={onClick}
  >
    <div className="flex items-center">
      {showInfoIcon ? <InfoIcon color="white" className="mr-1" /> : null}
      <Text weight="bold" className="inline pr-2 text-white">
        {title}
      </Text>
    </div>
    {showArrow && (
      <i
        className={`fas fa-chevron-${expanded ? "down" : "right"} text-white`}
      />
    )}
  </button>
);

export default TitleDashboard;
